import { render, staticRenderFns } from "./approve-vendor.vue?vue&type=template&id=1820b362&scoped=true"
import script from "./approve-vendor.vue?vue&type=script&lang=js"
export * from "./approve-vendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820b362",
  null
  
)

export default component.exports